import * as React from 'react';

function SvgToggles2(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M9.465 10H12a2 2 0 110 4H9.465c.34-.588.535-1.271.535-2 0-.729-.195-1.412-.535-2z' />
			<path d='M6 15a3 3 0 100-6 3 3 0 000 6zm0 1a4 4 0 110-8 4 4 0 010 8zm.535-10a3.975 3.975 0 01-.409-1H4a1 1 0 010-2h2.126c.091-.355.23-.69.41-1H4a2 2 0 100 4h2.535z' />
			<path d='M14 4a4 4 0 11-8 0 4 4 0 018 0z' />
		</svg>
	);
}

export default SvgToggles2;
